import { Component, Input } from '@angular/core';
import { GetCustomTypeIcon, GetCustomTypeIconWidth } from 'src/app/shared/data/product-types';

@Component({
  selector: 'asset-icon-renderer',
  template: `
    <img
      [src]="getCustomTypeIcon(rowData?.ProductTypeId)"
      [style.max-height.px]="32"
      [style.max-width.px]="getCustomTypeIconWidth(rowData?.ProductTypeId)"
    />
  `,
  standalone: true,
})
export class AssetIconRenderer {
  @Input() rowData: any;

  public getCustomTypeIcon = GetCustomTypeIcon;
  public getCustomTypeIconWidth = GetCustomTypeIconWidth;
}
